import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import { _$ } from '../../../controllers/dom';

const Status = (props) => {
    const { locale, listStatus, vehicle, ModuleRP } = props;
    const [status, setStatus] = useState(vehicle.status);

    const changeStatus = () => {
        ModuleRP.changeStatusVehicle(vehicle.id, _$('status').value);
    };

    useEffect(() => {
        setStatus(vehicle.status);
    }, [vehicle]);

    return (
        <div>
            <h5>{locales[locale].config.status}</h5>
            <select
                className='form-control'
                id='status'
                defaultValue={status}
                onChange={(e) => {
                    vehicle.status = Number(e.target.value);
                }}
            >
                {
                    listStatus.map((status) => {
                        if (!status.informative) {
                            return (
                                <option key={status.code} value={status.code}>
                                    {status.name}
                                </option>
                            );
                        }
                    })
                }
            </select>
            <button
                type='button'
                className='btn btn-primary m-1 float-right'
                data-dismiss='modal'
                onClick={changeStatus}
            >
                {locales[locale].config.update}
            </button>
        </div>
    );
};

export default Status;
